import { clsx } from 'clsx';
import React from 'react';

import * as styles from './Tile.css';

// TileWrapper component
interface TileWrapperProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

export const TileWrapper: React.FC<TileWrapperProps> = ({
  children,
  className,
  onClick,
  style,
}) => (
  <div
    className={clsx(styles.tileWrapper, className)}
    onClick={onClick}
    style={style}
  >
    {children}
  </div>
);

export const TileWrapperIndented: React.FC<TileWrapperProps> = ({
  children,
  className,
  onClick,
  style,
}) => (
  <div
    className={clsx(styles.tileWrapperIndented, className)}
    onClick={onClick}
    style={style}
  >
    {children}
  </div>
);

export const TileHeader: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <div className={clsx(styles.tileHeader, className)}>{children}</div>
);

export const TileLeftLayout: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <div className={clsx(styles.tileLeftLayout, className)}>{children}</div>
);

// TileRightLayout component with columns parameter
interface TileRightLayoutProps {
  children: React.ReactNode;
  columns?: number;
  className?: string;
}

export const TileRightLayout: React.FC<TileRightLayoutProps> = ({
  children,
  columns = 2,
  className,
}) => {
  const clampedColumns = Math.max(
    1,
    Math.min(5, columns)
  ) as keyof typeof styles.tileRightLayoutColumns;

  return (
    <div
      className={clsx(
        styles.tileRightLayoutBase,
        styles.tileRightLayoutColumns[clampedColumns],
        className
      )}
    >
      {children}
    </div>
  );
};
